import React, { useEffect } from 'react';
import { X } from 'lucide-react';

export default function Modal({ open, onClose, children }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === 'Escape') onClose && onClose(); };
    document.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prev;
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0,
        background: 'rgba(15, 19, 32, 0.55)',
        backdropFilter: 'blur(4px)',
        WebkitBackdropFilter: 'blur(4px)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        zIndex: 2000,
        padding: 20,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        style={{
          background: 'var(--surface-0)',
          borderRadius: 'var(--radius-lg)',
          maxWidth: 880, width: '100%', maxHeight: '90vh',
          overflow: 'hidden',
          position: 'relative',
          boxShadow: '0 30px 70px -20px rgba(15, 19, 32, 0.5)',
          border: '1px solid var(--ink-100)',
          display: 'flex', flexDirection: 'column',
        }}
      >
        <button
          onClick={onClose}
          aria-label="Close"
          style={{
            position: 'absolute', top: 16, right: 16,
            width: 36, height: 36,
            borderRadius: 8,
            background: 'var(--surface-2)',
            color: 'var(--ink-600)',
            border: 'none',
            cursor: 'pointer',
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            zIndex: 1,
          }}
        >
          <X size={18} />
        </button>
        <div style={{ overflowY: 'auto', padding: 'var(--sp-10) var(--sp-10) var(--sp-8)' }}>
          {children}
        </div>
      </div>
    </div>
  );
}
